import Navbar from '../Navbar/Navbar'
import Footer from '../Home/Footer'
import PrivacyPolicy from '../Privacyandterms/Privacypolicy'


const Privacypage = () => {
  return (
    <div>
        <Navbar/>
        <PrivacyPolicy/>
        <Footer/>
        

    </div>
  )
}

export default Privacypage